import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import axios from 'axios';
import AddPatientModal from './addPatient'; // Le composant modal
import EditPatientModal from './editPatient'; // Le composant modal
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CTab,
    CTabContent,
    CTabList,
    CTabPanel,
    CTabs,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow
} from '@coreui/react'
import { FaRedoAlt, FaExchangeAlt, FaFilter, FaSearch, FaDownload, FaFolderOpen, FaEllipsisV, FaEdit } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsArrowUpLeft, BsArrowDownUp } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import '../../../assets/css/ClientSidebar.css';

import Adminprofil from '../../../assets/images/adminprofil.png';
import { Tooltip } from 'react-tooltip'

import api from '../../../service/caller';
import { ToastContainer, toast } from 'react-toastify';

const PatientList = () => {

    const [UserData, setUserData] = useState([]);

    const [visibleEdit, setVisibleEdit] = useState(false);
    const [visible, setVisible] = useState(false);
    const [appointments, setAppointments] = useState([]);
    const [patients, setPatients] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalPatients, setTotalPatients] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const limit = 10; // Nombre de patients par page
    const [selectedUser, setSelectedUser] = useState(null); // Utilisateur sélectionné pour modification

    // Fonction pour ouvrir le modal et définir le contenu
    // const handleIconClick = (content) => {
    //     setModalContent(content);  // Définit le contenu du modal
    //     setVisible1(true);  // Ouvre le modal
    // };


    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                console.log('jkk', response.data);
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);


    const fetchPatients = async (hospitalIds) => {
        if (!hospitalIds || hospitalIds.length === 0) {
            console.error("Erreur: hospitalIds est vide ou non disponible");
            return;
        }
        try {
            // Faire l'appel API avec un tableau de hospitalIds
            const response = await api.get(`/clinic/patients`, {
                params: { hospitalIds } // Envoi d'un tableau d'IDs de hospital
            });

            console.log("Nombre de patients reçus:", response.data.patients.length);
            setPatients(response.data.patients);

        } catch (error) {
            console.error('Erreur lors de la récupération des patients:');
            if (error.response) {
                // La requête a été faite et le serveur a répondu avec un code d'état
                console.error('Données de réponse:', error.response.data);
                console.error('Statut:', error.response.status);
            } else if (error.request) {
                // La requête a été faite mais aucune réponse n'a été reçue
                console.error('Requête sans réponse:', error.request);
            } else {
                // Une erreur s'est produite lors de la configuration de la requête
                console.error('Erreur de configuration:', error.message);
            }
        }
    };

    // Utilisation de useEffect pour charger les données
    useEffect(() => {
        if (UserData && UserData.hospital_id && Array.isArray(UserData.hospital_id) && UserData.hospital_id.length > 0) {
            // Vérifiez si hospital_id est un tableau et le passez à fetchPatients
            const hospitalIds = UserData.hospital_id;
            fetchPatients(hospitalIds);
        } else {
            console.error("UserData ou hospital_id non disponible pour fetchPatients");
        }
    }, [UserData]);



    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const hospitalIds = Array.isArray(UserData.hospital_id) ? UserData.hospital_id : [UserData.hospital_id];

                // Créez une requête pour chaque hospitalId
                const promises = hospitalIds.map(hospitalId =>
                    api.get(`/clinic/getAppointmentlist?hospitalId=${hospitalId._id || hospitalId}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                );

                const responses = await Promise.all(promises);

                // Combiner toutes les données des réponses
                const allAppointments = responses.flatMap(response => response.data);

                setAppointments(allAppointments);

                // Filtrer les rendez-vous selon l'utilisateur
                if (UserData.role && UserData.role.name === 'medtinz_client_patient') {
                    const patientResponse = await api.get('/clinic/getPatientByUserId', {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    const patientId = patientResponse.data._id;
                    const filteredAppointments = allAppointments.filter(appointment =>
                        appointment.patientId._id === patientId
                    );

                    setAppointments(filteredAppointments);
                }
            } catch (error) {
                console.error('Error fetching appointments:', error);
                toast.error("Failed to fetch appointments");
            }
        };

        if (UserData && UserData.hospital_id) {
            fetchAppointments();
        }
    }, [UserData]);

    // search

    const handleSearchChange = async (e) => {
        const value = e.target.value; // Récupérer la valeur entrée par l'utilisateur
        setSearchTerm(value);

        if (!value) {
            // Si le champ est vide, rechargez la liste complète
            fetchPatients(currentPage);
            return;
        }

        setLoading(true);
        try {
            const response = await api.get(`/clinic/patients/searchpatient`, {
                params: {
                    query: value, // Envoyer la valeur unique au backend
                },
            });
            setPatients(response.data); // Mettre à jour la liste des patients
        } catch (error) {
            console.error('Erreur lors de la recherche des patients:', error);
            setPatients([]); // Si une erreur se produit, afficher une liste vide
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPatients(currentPage); // Récupère les données de la page actuelle au chargement
    }, [currentPage]);

    const goToNextPage = () => {
        if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
    };

    const handlePatientAdded = (newPatient) => {
        setPatients((prev) => [...prev, newPatient]);
    };
    const handlePatientEdited = (newPatient) => {
        setPatients((prev) => [...prev, newPatient]);
    };

    const handleEditClick = (user) => {
        // console.log(user);

        setSelectedUser(user); // Mettre l'utilisateur sélectionné
        setVisibleEdit(true); // Ouvrir le modal
    };

    return (
        <div className="dashboard-header" >
            <CHeader position="sticky" style={{ backgroundColor: '#DFEAF5' }}>
                <CContainer fluid className="d-flex align-items-center">
                    <div className='row w-100'>
                        {/* Barre de recherche */}
                        <div className="pagetittle col">
                            <h4><b>Patient Management</b></h4>
                            <p>Home <BsChevronRight className='mx-2' style={{ fontSize: "12px" }} />  Dashboard <BsChevronRight style={{ fontSize: "12px" }} className='mx-2' />  <span style={{ color: '#191B1C' }}>Patient Management</span></p>
                        </div>
                        {/* Profil utilisateur */}

                        <div className=' d-flex col justify-content-end'>
                            <CHeaderNav>
                                <CNavItem>
                                    <CNavLink href="#" className="d-flex ms-auto">
                                        <img src={Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                                        <div>
                                            <span className="ms-2" style={{ color: 'black' }} >{UserData.firstname} {UserData.lastname}</span>
                                            <p className="ms-2" style={{ color: 'black' }} >{UserData.role?.name}</p>
                                        </div>
                                    </CNavLink>
                                </CNavItem>
                            </CHeaderNav>
                        </div>
                    </div>
                </CContainer>
            </CHeader>

            <div className="Patientlist mt-2"  >
                <div className='tabsection'>
                    <CRow>
                        <CCol xs={12}>
                            <CCard className="card mb-4 p-4">
                                <CCardBody>
                                    <CTabs activeItemKey="Allpatient">
                                        <CTabList variant="underline" className='border-bottom mx-auto'>
                                            <CTab itemKey="Allpatient">All Patient</CTab>
                                            <CTab itemKey="dayrecord">Day's record</CTab>
                                        </CTabList>
                                        <CTabContent>
                                            <CTabPanel className="p-3" itemKey="Allpatient">
                                                <div className='tablist ' >
                                                    <div className='patientlistline'>
                                                        <div className="search-container w-80">
                                                            <div className="search-bar">
                                                                <FaSearch size="sm" className="search-icon " style={{ width: '20px', height: '20px' }} />
                                                                <input
                                                                    className='ms-4'
                                                                    type="text"
                                                                    placeholder="Search for a patient (Enter ID, name or Tel)"
                                                                    value={searchTerm}
                                                                    onChange={handleSearchChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='registeruserbtn ms-auto'>
                                                            <CButton onClick={() => setVisible(true)} className="registernewbtn ms-auto d-flex align-items-center" active tabIndex={-1}>
                                                                <BsPersonPlus className='mx-2' /> Register New patient
                                                            </CButton>
                                                        </div>
                                                    </div>
                                                    <AddPatientModal
                                                        visible={visible}
                                                        onClose={() => setVisible(false)}
                                                        onPatientAdded={handlePatientAdded}
                                                    />
                                                    {/* <div className=''>
                                                        <div className="filter-bar">
                                                            <button className="filter-button">
                                                                Filter By<FaFilter className="icon" />
                                                            </button>
                                                            <button className="filter-button">
                                                                Order Type<FaExchangeAlt className="icon" />
                                                            </button>
                                                            <button className="reset-button">
                                                                <FaRedoAlt className="icon" /> Reset Filter
                                                            </button>
                                                        </div>
                                                    </div> */}


                                                    <div className='patientlisttable'>
                                                        <CTable className="mt-5 ctable-no-border " align="middle" responsive>
                                                            <CTableHead>
                                                                <CTableRow className='tablehead'>
                                                                    <CTableHeaderCell scope="col">ID</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">NAME</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">ADDRESS</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">LAST VISIT</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">PHONE</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">ACTION</CTableHeaderCell>
                                                                </CTableRow>
                                                            </CTableHead>
                                                            <CTableBody>
                                                                {patients.map((patient) => (
                                                                    <CTableRow className='ctable-row' key={patient._id}>
                                                                        <CTableDataCell align="middle">{patient.patientId}</CTableDataCell>
                                                                        <CTableDataCell>{patient.lastname} {patient.firstname}</CTableDataCell>
                                                                        <CTableDataCell>{patient.address}</CTableDataCell>
                                                                        <CTableDataCell>{patient.email}</CTableDataCell>
                                                                        <CTableDataCell>{patient.phone}</CTableDataCell>
                                                                        <CTableDataCell>
                                                                            <div className="flex items-center space-x-4">
                                                                                <div className="dropdown-center p-0 bg-none" style={{ border: 'none' }}>
                                                                                    <FaEllipsisV
                                                                                        className="bg-none border-0 p-0"
                                                                                        data-coreui-toggle="dropdown"
                                                                                        aria-expanded="true"
                                                                                        style={{ border: 'none', color: 'Green' }}
                                                                                    />
                                                                                    <ul className="dropdown-menu">
                                                                                        <li>
                                                                                            <a
                                                                                                className="dropdown-item"
                                                                                                href={`/hospitaladmin/patientfilemedical/${patient._id}`}
                                                                                            >
                                                                                                <FaFolderOpen
                                                                                                    className="bg-none border-0 p-0"
                                                                                                    data-coreui-toggle="dropdown"
                                                                                                    aria-expanded="true"
                                                                                                    style={{ border: 'none' }}
                                                                                                /> Open Folder
                                                                                            </a>
                                                                                        </li>
                                                                                        <li>
                                                                                            <CButton
                                                                                                // onClick={() => setVisibleEdit(true)} 
                                                                                                onClick={() => handleEditClick(patient)}
                                                                                                className="dropdown-item bg-none border-0" tabIndex={-1}>
                                                                                                <FaEdit
                                                                                                    // onClick={() => setVisibleEdit(true)}
                                                                                                    className="bg-none border-0 p-0"
                                                                                                    data-coreui-toggle="dropdown"
                                                                                                    aria-expanded="true"
                                                                                                    style={{ border: 'none' }}
                                                                                                /> Edit {patient?.firstname}
                                                                                            </CButton>
                                                                                            <EditPatientModal
                                                                                                visibleEdit={visibleEdit}
                                                                                                patientSelected={selectedUser}
                                                                                                onClose={() => setVisibleEdit(false)}
                                                                                                onPatientEdit={handlePatientEdited}
                                                                                            />
                                                                                        </li>
                                                                                        <li>
                                                                                            <a
                                                                                                className="dropdown-item"
                                                                                                href={`/patientcard/${patient._id}`}
                                                                                            >
                                                                                                <FaDownload
                                                                                                    className="bg-none border-0 p-0"
                                                                                                    data-coreui-toggle="dropdown"
                                                                                                    aria-expanded="true"
                                                                                                    style={{ border: 'none' }}
                                                                                                /> Download
                                                                                            </a>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </CTableDataCell>
                                                                    </CTableRow>
                                                                ))}
                                                            </CTableBody>
                                                        </CTable>
                                                    </div>
                                                </div>
                                            </CTabPanel>
                                            <CTabPanel className="p-3" itemKey="dayrecord">
                                                <div className='tablist ' >
                                                    <div className='patientlistline'>
                                                        <div className="search-container w-80">
                                                            <div className="search-bar">
                                                                <FaSearch size="sm" className="search-icon " style={{ width: '20px', height: '20px' }} />
                                                                <input
                                                                    className='ms-4'
                                                                    type="text"
                                                                    placeholder="Search for a patient (Enter ID, name or Tel)"
                                                                    value={searchTerm}
                                                                    onChange={handleSearchChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='registeruserbtn ms-auto'>
                                                            <CButton onClick={() => setVisible(true)} className="registernewbtn ms-auto d-flex align-items-center" active tabIndex={-1}>
                                                                <BsPersonPlus className='mx-2' /> Register New patient
                                                            </CButton>
                                                        </div>
                                                    </div>
                                                    <AddPatientModal
                                                        visible={visible}
                                                        onClose={() => setVisible(false)}
                                                        onPatientAdded={handlePatientAdded}
                                                    />
                                                    {/* <div className=''>
                                                        <div className="filter-bar">
                                                            <button className="filter-button">
                                                                Filter By<FaFilter className="icon" />
                                                            </button>
                                                            <button className="filter-button">
                                                                Order Type<FaExchangeAlt className="icon" />
                                                            </button>
                                                            <button className="reset-button">
                                                                <FaRedoAlt className="icon" /> Reset Filter
                                                            </button>
                                                        </div>
                                                    </div> */}


                                                    <div className='patientlisttable'>
                                                        <CTable className="mt-5 ctable-no-border " align="middle" responsive>
                                                            <CTableHead>
                                                                <CTableRow className='tablehead'>
                                                                    <CTableHeaderCell scope="col">ID</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">NAME</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">ADDRESS</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">PHONE</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">STATUS</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">PAYMENT STATUS</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Patient FILE</CTableHeaderCell>
                                                                </CTableRow>
                                                            </CTableHead>
                                                            <CTableBody>
                                                                {appointments.map((appointment) => (
                                                                    <CTableRow className="ctable-row" key={appointment._id}>
                                                                        <CTableDataCell>{appointment.patientId?.patientId || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>{appointment.patientId?.firstname || 'Unknown'} {appointment.patientId?.lastname || 'Unknown'}</CTableDataCell>
                                                                        <CTableDataCell>{appointment.patientId?.address || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>{appointment.patientId?.phone || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>
                                                                            <span className={appointment.paymentStatus ? 'coloredsucess' : 'coloredwarning'}>
                                                                                {appointment.paymentStatus ? 'Paid' : 'Pending'}</span>
                                                                        </CTableDataCell>
                                                                        <CTableDataCell>
                                                                            <span className={appointment.status === 'Scheduled' ? 'coloredsucess' : 'coloredechec'}>
                                                                                {appointment.status}
                                                                            </span>
                                                                        </CTableDataCell>

                                                                        <CTableDataCell>
                                                                            <Link to={`/hospitaladmin/patientfilemedical/${appointment.patientId?._id}`} className="openfilepatient">
                                                                                <BsArrowUpLeft /> Open patient file
                                                                            </Link>
                                                                        </CTableDataCell>
                                                                    </CTableRow>
                                                                ))}

                                                            </CTableBody>
                                                        </CTable>
                                                    </div>
                                                </div>
                                            </CTabPanel>
                                        </CTabContent>
                                    </CTabs>
                                    {/* paginate */}
                                    <div className='paginate me-5'>
                                        <p className='mt-3'>
                                            Showing {(currentPage - 1) * limit + 1}-{Math.min(currentPage * limit, totalPatients)} of {totalPatients}
                                        </p>
                                        <div className='actionbtn'>
                                            <div className='left' onClick={goToPreviousPage}>
                                                <BsChevronLeft className='pagicon' />
                                            </div>
                                            <div className='right' onClick={goToNextPage}>
                                                <BsChevronRight className='pagicon' />
                                            </div>
                                        </div>
                                    </div>
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </CRow>
                </div>
            </div>
        </div >


    );
}

export default PatientList;
